// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-1813b990],H2[data-v-1813b990]{position:relative}H2[data-v-1813b990]{margin:0 0 20px 0}.filter[data-v-1813b990]{line-height:45px}.right-action[data-v-1813b990]{position:absolute;top:10px;right:10px}", ""]);
// Exports
module.exports = exports;
